export default "__VITE_ASSET__CnR5m_gQ__"